// Helper to build YouTube embed URLs with subtitle preferences based on user language.
// Reads the selected language from localStorage ("cv_lang", set by LanguageSwitcher).
// If the user picked English or Portuguese, YouTube will auto-load captions translated
// to that language. Spanish (original audio) keeps captions off by default.
export const ytEmbedUrl = (videoId, opts = {}) => {
  let lang = "es";
  try {
    if (typeof window !== "undefined") {
      lang = window.localStorage.getItem("cv_lang") || "es";
    }
  } catch { /* noop */ }

  const params = new URLSearchParams({
    rel: "0",
    cc_load_policy: lang === "es" ? "0" : "1",
    cc_lang_pref: lang,
    hl: lang,
  });
  if (opts.start) params.set("start", String(opts.start));
  return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
};
